<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>分部维护</h2>
        <p>成交地点在财务核算中对应这里维护的分部</p>
      </div>
      <el-button
        type="primary"
        @click="open()"
      >
        新增分部
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        v-loading="loading"
        :data="rows"
      >
        <el-table-column
          prop="name"
          label="分部名称"
        />
        <el-table-column
          prop="code"
          label="编码"
        />
        <el-table-column
          prop="manager_name"
          label="负责人"
        />
        <el-table-column
          prop="member_count"
          label="员工数"
        />
        <el-table-column label="状态">
          <template #default="{ row }">
            <el-tag :type="row.enabled ? 'success' : 'info'">
              {{ row.enabled ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template #default="{ row }">
            <el-button
              link
              type="primary"
              @click="open(row)"
            >
              编辑
            </el-button>
            <el-button
              link
              :type="row.enabled ? 'danger' : 'success'"
              @click="toggle(row)"
            >
              {{ row.enabled ? '停用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-model="dialog"
      :title="form.id ? '编辑分部' : '新增分部'"
      width="500px"
    >
      <el-form label-width="90px">
        <el-form-item
          label="名称"
          required
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="form.code" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="form.sort"
            :min="0"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { organizationApi } from '../api'
const rows = ref([]),
  loading = ref(false),
  dialog = ref(false),
  saving = ref(false),
  form = reactive({ id: null, name: '', code: '', sort: 0 })
const load = async () => {
  loading.value = true
  try {
    rows.value = (await organizationApi.branches()) || []
  } finally {
    loading.value = false
  }
}
const open = (r) => {
  Object.assign(form, {
    id: r?.id || null,
    name: r?.name || '',
    code: r?.code || '',
    sort: r?.sort || 0,
  })
  dialog.value = true
}
const save = async () => {
  if (!form.name) return ElMessage.warning('请填写分部名称')
  saving.value = true
  try {
    form.id
      ? await organizationApi.updateBranch(form.id, form)
      : await organizationApi.createBranch(form)
    ElMessage.success('保存成功')
    dialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const toggle = async (r) => {
  try {
    await ElMessageBox.confirm(
      `确认${r.enabled ? '停用' : '启用'}该分部？`,
      '提示'
    )
    await organizationApi.toggleBranch(r.id, !r.enabled)
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
